module.exports = __webpack_public_path__ + "img/stock.7df73274.jpg";